import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import locale from "@amcharts/amcharts4/lang/pt_BR.js";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

function montarGraficoStackedColumn({ cores, component, nome, dados = [], animacaoAtivada=true, fontColor="#000" }) {
    if (component) component.dispose();

    if(animacaoAtivada){
        am4core.useTheme(am4themes_animated);
    }

    const chart = am4core.create(nome, am4charts.XYChart);

    // fixa altura do gráfico (usa altura do container)
    chart.svgContainer.htmlElement.style.height = "80%";
    chart.svgContainer.htmlElement.style.maxHeight = "80%";
    chart.svgContainer.htmlElement.style.minHeight = "80%";

    chart.language.locale = locale;
    chart.language.locale["_decimalSeparator"] = ",";
    chart.language.locale["_thousandSeparator"] = ".";
    chart.language.locale["_date_month"] = "MMM";
    // chart.numberFormatter.numberFormat = "###,###,###,###.00";

    // ----------------------------------------------------------
    // 1) MONTAR chart.data NO FORMATO CERTO
    // ----------------------------------------------------------
    let linha = { label: "" };

    dados.forEach((item, index) => {
        linha["serie" + index] = Number(item.value) || 0;
    });

    chart.data = [linha];

    // ----------------------------------------------------------
    // 2) EIXO X — apenas UMA categoria fixa
    // ----------------------------------------------------------
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "label";
    categoryAxis.renderer.grid.template.location = 0;

    // 👉 OCULTA O LABEL DO EIXO X
    categoryAxis.renderer.labels.template.disabled = true;

    // (Opcional) oculta a linha e grid do eixo X também
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.line.disabled = true;
    // ----------------------------------------------------------
    // 3) EIXO Y
    // ----------------------------------------------------------
    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.labels.template.fill = am4core.color("#fff");
    valueAxis.extraMax = 0.2; // 20% de espaço extra no topo
    valueAxis.min = 0;
    // desabilita tooltip do eixo Y
    // valueAxis.tooltip.disabled = true;
    valueAxis.cursorTooltipEnabled = false;

    dados.forEach((item, index) => {
        const serie = chart.series.push(new am4charts.ColumnSeries());
        serie.dataFields.valueY = "serie" + index;
        serie.dataFields.categoryX = "label";

        serie.name = item.category;
        serie.stacked = item.stacked === true;
        serie.totalStack = item.totalStack || 0;

        if (cores && cores[index]) {
            serie.fill = cores[index];
            serie.stroke = cores[index];
        }

        serie.columns.template.width = am4core.percent(80);

        // tooltip normal
        serie.tooltipText = `${item.category}: [bold]{valueY.formatNumber("###,###,###,###.00")} kWh[/]`;

        // =====================================================================
        // 1) BULLET NORMAL NO TOPO (por série)
        // =====================================================================
        let bullet = serie.bullets.push(new am4charts.LabelBullet());
        bullet.label.fontSize = "0.6rem";
        bullet.label.fontWeight = "bold";
        bullet.label.fill = am4core.color(fontColor);
        bullet.dy = 10;

        // Só mostra valores maiores que zero
        bullet.label.adapter.add("text", function (text, target) {
            const val = target.dataItem ? target.dataItem.valueY : 0;
            return val > 0 ? "{valueY.formatNumber('###,###,##0.00')}" : "";
        });

        // 🔥 Ajuste automático da posição (dentro ou acima da coluna)
        bullet.adapter.add("dy", function (dy, target) {
            if (!target.dataItem || !target.dataItem.column) return dy;

            const columnHeight = target.dataItem.column.pixelHeight; // altura real da coluna em px
            const fontHeight = parseFloat(target.label.fontSize) * 16; // converte rem → px aprox.

            // Se a coluna for menor que a altura da letra, posiciona ACIMA
            if (columnHeight < fontHeight) {
                return - 4; // sobe o label acima da coluna
            }

            return dy; // mantém o padrão
        });

        // =====================================================================
        // 2) TOTAL DA PILHA — apenas para séries que possuem totalStack manual
        // =====================================================================
        if (item.totalStack > 0 && item.stacked) {
            let bulletStack = serie.bullets.push(new am4charts.LabelBullet());
            bulletStack.label.fontSize = "0.6rem";
            bulletStack.label.fontWeight = "bold";
            bulletStack.label.fill = am4core.color("#fff");
            bulletStack.dy = -15;

            bulletStack.label.text = item.totalStack.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }
    });

    chart.cursor = new am4charts.XYCursor();
    chart.cursor.behavior = "none";
    chart.cursor.lineX.disabled = true;
    chart.cursor.lineY.disabled = true;

    // 🔥 exibe tooltip de TODAS as séries juntas
    chart.cursor.maxTooltipDistance = -1;
    chart.cursor.xAxis = categoryAxis;

    chart.tooltip.label.minWidth = 200;
    chart.tooltip.label.textAlign = "left";

    return chart;
}

export { montarGraficoStackedColumn };
